var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.60938C1 1.27283 1.26117 1 1.58333 1H14.4167C14.7389 1 15 1.27283 15 1.60938V3.64063C15 3.97718 14.7389 4.25001 14.4167 4.25001H1.58333C1.26117 4.25001 1 3.97718 1 3.64063V1.60938ZM1 6.48438C1 6.14784 1.26117 5.87501 1.58333 5.87501H8.19446C8.51662 5.87501 8.77779 6.14784 8.77779 6.48438V14.3906C8.77779 14.7272 8.51662 15 8.19446 15H1.58333C1.26117 15 1 14.7272 1 14.3906V6.48438ZM10.9167 5.87501C10.5945 5.87501 10.3333 6.14784 10.3333 6.48438V12.7656C10.3333 13.1022 10.5945 13.375 10.9167 13.375H14.4167C14.7389 13.375 15 13.1022 15 12.7656V6.48438C15 6.14784 14.7389 5.87501 14.4167 5.87501H10.9167Z",
    fill: "#5D6588"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDashboard);
export default __webpack_public_path__ + "static/media/menu-dashboard.de73991bd597519fadb08a48d652e737.svg";
export { ForwardRef as ReactComponent };